export default "https://cdn-static.gokick.com/assets/ac547ee441cd23ce845c1e2810a666ddd08d044b/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";